<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Reset Aligner Serial Number - {{currentSerialNumber}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          v-model="newSerialNumber"
          outlined
          label="New Serial Number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue" @click="onChangeClick()">Change</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    currentSerialNumber: String,
  },

  data() {
    return {
      newSerialNumber: '',
    };
  },

  methods: {
    onChangeClick() {
      this.$emit('close', { currentSerialNumber: this.currentSerialNumber, newSerialNumber: this.newSerialNumber });
      this.newSerialNumber = '';
    },

    onCancelClick() {
      this.$emit('close', { newSerialNumber: null });
      this.newSerialNumber = '';
    },
  },
};
</script>
